<script>

    import axios from 'axios'

    export default {
        data() {
            return {
                state: 'unsubmitted',
                emailConfirm: '',
                emailsDoNotMatch: false,
                message: {
                    email: '',
                    subject: '',
                    message: '',
                    type_of_question: 'general',
                    country: '',
                    notify_email: ''
                },
                errors: {},
            }
        },
        mounted() {
        },
        props: ['country', 'notify', 'token', 'endpoint'],
        computed: {
            unsubmitted () {
                return this.state == 'unsubmitted'
            },
            sending () {
                return this.state == 'sending'
            },
            sent () {
                return this.state == 'sent'
            },
            emailValid () {
                return (!this.message.email.length || (this.message.email.length && this.message.email == this.emailConfirm)) ? true : false
            },
            api() {
                return axios.create({
                    headers: {
                        'Authorization': 'Token token=' + this.token,
                    }
                })
            },
        },
        methods: {
            submit () {
                this.emailsDoNotMatch = false
                this.$set(this.message, 'country', this.country)
                this.$set(this.message, 'notify_email', this.notify)
                if (this.emailValid) {
                    this.state = 'sending'
                    this.api.post(this.endpoint, this.message)
                        .then((response) => {
                            this.state = 'sent'
                        }, (error) => {
                            this.errors = error.response.data
                            this.state = 'unsubmitted'
                        })
                } else {
                    this.emailsDoNotMatch = true
                }
            },
            hasError(field) {
                let data = false
                for (let key of Object.keys(this.errors)) {
                    if (field == key) {
                        data = true
                        break
                    }
                }
                return data
            },
            unsetForm() {
                this.$set(this.message, 'email', '');
                this.$set(this.message, 'subject', '');
                this.$set(this.message, 'message', '');
                this.$set(this.message, 'type_of_question', 'general');
                this.emailConfirm = ''
                this.state = 'unsubmitted'
            }
        }
    }
</script>
